import { TestCase } from '@/models/test-case/testcase';
import { MailWizzInstanceService } from './mail-wizz-instance.serive';
import { TestCaseResponse } from '@/models/test-case/test-case-response';
import { TestCaseCreateOptions } from '@/models/test-case/test-case-create-options';

export class TestCaseService extends MailWizzInstanceService {
    protected getResourceUrl() { return 'api/testcases' };
    protected getResponseMapper() { return TestCaseResponse.parseJson }

    getById(id: number) : Promise<TestCaseResponse> {
        return this.get({
            resourceId: id,
            responseMapper: TestCaseResponse.parseJson
        })
    }

    getTestCasesPage(page: number, pageSize: number) : Promise<TestCaseResponse[]> {
        return this.get({
            params: {
                limit: pageSize,
                skip: (page - 1) * pageSize
            }
        })
    }

    getTotalCount() : Promise<number> {
        return this.get({
            path: '/total'
        })
    }

    nameIsUsed(name: string) : Promise<boolean> {
        return this.get({
            path: `/checkname/${encodeURIComponent(name)}`
        })
    }

    createTestCase(testCase: TestCase, { delaySend }: TestCaseCreateOptions) {
        return this.post({
            data: {
                name: testCase.name,
                listId: testCase.listId,
                subjects: testCase.subjects,
                bodies: testCase.bodies,
                deliveryServers: testCase.deliveryServers,
                trackingDomains: testCase.trackingDomains,
                useDeliveryServerTrackingDomain: testCase.useDeliveryServerTrackingDomain,
                campaigns: testCase.campaigns.map(campaign => {
                    return {
                        subject: campaign.subject,
                        listId: campaign.list.mailWizzEntityId,
                        fromName: campaign.fromName,
                        fromEmail: campaign.fromEmail,
                        replyTo: campaign.replyTo,
                        htmlTemplate: campaign.body,
                        deliveryServerId: campaign.deliveryServer.mailWizzEntityId,
                        trackingDomainId: campaign.trackingDomain.mailWizzEntityId,
                        service: campaign.service,
                        providers: campaign.providers,
                    }
                })
            },
            params: {
              delaySend: delaySend ? 1 : 0,
            }
        })
    }
}

export const testCaseService = new TestCaseService();
